import { AxiosResponse } from 'axios';
import { TGetContactDetails, TGetContactAccounts } from '@dekafvv/sharedfrontend';
import { useQuery } from 'react-query';
import { getContact } from './migratedCalls';
import { getContactAccounts } from './contacts';

export const getContactDetails = ({
    clientId,
    refetchOnMount = true,
    onError,
}: {
  clientId: string;
  refetchOnMount?: boolean;
  onError?: () => void;
}) => {
    const query = useQuery<
    AxiosResponse<TGetContactDetails>,
    null | { message: string },
    TGetContactDetails
  >({
      queryKey: ['contactDetails', 'shared', clientId],
      queryFn: () => getContact(clientId).then(({ data }) => data),
      onError,
      refetchOnWindowFocus: false,
      refetchOnMount,
  });

    return query;
};

export const useGetContactAccounts = ({
    clientId,
    refetchOnMount = true,
}: {
  clientId: string;
  refetchOnMount?: boolean;
}) => {
    const query = useQuery<
    AxiosResponse<TGetContactAccounts>,
    null | { message: string },
    TGetContactAccounts
  >({
      queryKey: ['getContactAccounts', clientId],
      queryFn: () => getContactAccounts({ clientId }).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
  });

    return query;
};
